export default __webpack_public_path__ + "static/media/logoBingo.a3c39766.png";